import { LinksApi } from '../../generated/api';
import configuration from './configuration';

export default new LinksApi(configuration);
